export enum Operation {
  CONTAINS = 'CONTAINS',
  EQ = 'EQ',
  NEQ = 'NEQ',
  GT = 'GT',
  GE = 'GE',
  LT = 'LT',
  LE = 'LE',
}
